<template>
  <div class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">送料・納期・配送</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="order_section">
            <div class="order_area">
              <div class="order_title">送料について</div>
              <div class="order_msg">
                送料はご注文決定前に郵便番号を入力することでリアルタイムに計算され表示されますのでご確認ください。
              </div>
            </div>
            <div class="order_area">
              <div class="order_title">納期について</div>
              <div class="order_msg">
                <div>
                  注文を受けてから製造するお日にちをいただきます。
                </div>
                <div>
                  詳細なお届け日はカートに追加後、購入画面より選択ください。
                </div>
                <div>
                  ※商品によってお届け時期が異なります。
                </div>
                <div>
                  ※ご入金状況や、土曜日・日曜日・祝日を挟む場合は、配送が遅れる場合がございます。
                </div>
              </div>
            </div>
            <div class="order_area">
              <div class="order_title">配送について</div>
              <div class="order_msg">
                <div>
                  玄関先までのお届けです。室内への搬入、設置は行っておりません。
                </div>
                <div>
                  建物の状況により、玄関前ではなく建物1階でのお引渡しとなる場合がございます。
                  配達員が1人でおうかがいした場合にお届けする建物や、周囲の状況によりお客様に玄関先までの搬入を
                  お手伝いいただく場合がございます。
                </div>
                <div>
                  ご注文の際にはあらかじめ搬入経路をご確認ください。
                </div>
                <div>
                  搬入が不可能だった場合でのご注文後のキャンセル等はお受付できませんのでご注意ください。
                </div>
              </div>
            </div>
            <div class="order_area">
              <div class="order_title">組立設置サービスについて</div>
              <div class="order_msg">
                <div>
                  ご購入いただいた家具の組立設置を、専門業者が行うサービスです。
                </div>
                <div>
                  ※組立設置オプションには以下の費用が発生します。組立技術料：組立作業費および副資材、簡易養生材など。
                  諸経費：交通費、燃料代など。
                </div>
                <div>
                  ※ご注文後のキャンセルはお受けいたしかねます。なお日程変更は作業予定日の3日前までにお電話にてご連絡ください。
                </div>
              </div>
            </div>
            <div class="order_area">
              <div class="order_title">■サービスの流れ</div>
              <div class="order_msg">
                <div>
                  ①ご注文の際に「組立設置サービス」の有無を選択いただき作業希望日を選択してください。
                </div>
                <div>
                  ②ご注文完了後、組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。
                </div>
                <div>
                  ③ご指定の場所におうかがいし組立設置作業をいたします。
                </div>
                <div>
                  ④作業後は周辺を清掃、梱包材の回収を行います。
                </div>
                <div>
                  ⑤作業終了後、ご確認&検収サインをいただき完了です。
                </div>
              </div>
            </div>
            <div class="order_area">
              <div class="order_title">■家具組立設置サービス詳細に関するお問い合わせ</div>
              <div class="order_msg">
                <div>
                【キャンディルグループ】
                </div>
                <div>
                  メール ： mmstyle.te@candeal.co.jp
                </div>
                <div>
                  お電話 ： 03-5625-3095 (9:00～18:00)
                </div>
              </div>
            </div>
            <div class="order_area">
              <div class="order_title">営業時間外のご対応について</div>
              <div class="order_msg">
                休業日や営業時間外は、基本的にメールやお電話での依頼がお受けできず、翌営業日にご対応させていただく形となっております。 できるだけ柔軟に、迅速にご対応させていただきたいと取り組んでおりますのでご理解をよろしくお願いしくお願いいたします。
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'dcGuideOrder'
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-guide.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcGuideOrder.vue